import React from 'react';

type FormProps = {
    children: React.ReactNode;
    className?: string;
    onSubmit?: (e?: React.FormEvent) => void;
}
const Form: React.FC<FormProps> = ({ onSubmit, children, className }) => {
    return (
        <form className={className} onSubmit={onSubmit}>
            {children}
        </form>
    )
}

export default Form;